export default "__VITE_ASSET__11c4cd55__"